import { GelTheme } from 'components/GelTheme';
import { Box } from 'components/Layout/Box';
import { Typography } from 'components/Layout/Typography';
import * as React from 'react';
import styled from 'styled-components';

export interface LabelledValueProps {
  /** The label, which will be displayed in bold font weight. */
  label: string;

  /** The value, which will be displayed in normal font weight. */
  value: string;
}

const Label = styled(Typography)`
  display: block;
  margin-bottom: ${GelTheme.spacing(0.5)};
`;

const Value = styled(Typography)`
  display: inline-block;
`;

/**
 * A simple pairing of a label and a value with the correct font sizes, weights, and spacing.
 */
export const LabelledValue = ({ label, value }: LabelledValueProps) => {
  return (
    <Box as="p" my={[0.5, 1]}>
      <Label fontWeight="bold">{label}</Label>
      <Value>{value}</Value>
    </Box>
  );
};
